import React from 'react';

const Watermark = () => (
  <div
    style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      width: '180px',
      opacity: 0.52,
      pointerEvents: 'none',
      zIndex: 0,
      userSelect: 'none',
    }}
    aria-hidden="true"
  >
    <img src="/logo_expertiz.png" alt="" width="180" draggable="false" />
  </div>
);

export default Watermark;
